import React, { useState } from "react";
import api from "../api";
import { TextField, Button, Card, CardContent, Typography } from "@mui/material";

export default function Login({ onLoginSuccess }) {
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");

  const handleLogin = async () => {
    try {
      const res = await api.post("/auth", {
        username: username,
        upass: password   // ✅ must match backend property
      }, {
        headers: { "Content-Type": "application/json" }
      });
  
      const token = res.data.token;
      localStorage.setItem("authToken", token);
  
      onLoginSuccess();
    } catch (err) {
      console.error("Login error:", err);
      setError("Invalid username or password");
    }
  };
  

  return (
    <Card sx={{ maxWidth: 400, margin: "50px auto" }}>
      <CardContent>
        <Typography variant="h5">Login</Typography>
        <TextField
          label="Username"
          fullWidth
          margin="normal"
          value={username}
          onChange={(e) => setUsername(e.target.value)}
        />
        <TextField
          label="Password"
          type="password"
          fullWidth
          margin="normal"
          value={password}
          onChange={(e) => setPassword(e.target.value)}
        />
        {error && <Typography color="error">{error}</Typography>}
        <Button
          variant="contained"
          color="primary"
          fullWidth
          sx={{ marginTop: 2 }}
          onClick={handleLogin}
        >
          Login
        </Button>
      </CardContent>
    </Card>
  );
}